export enum ASSET_TYPE {
  CAR = 'car',
  MOTORBIKE = 'motorbike',
  CARAVAN = 'caravan',
  OTHER = 'other',
}

export const assetTypeMap = {
  [ASSET_TYPE.CAR]: 'Car',
  [ASSET_TYPE.MOTORBIKE]: 'Motorbike',
  [ASSET_TYPE.CARAVAN]: 'Caravan',
  [ASSET_TYPE.OTHER]: 'Other',
}

// refactored asset types
export enum REF_ASSET_TYPE {
  CAR = 1,
  MOTORBIKE = 2,
  CARAVAN = 3,
  OTHER = 4,
}

export const refAssetTypeMap = {
  [REF_ASSET_TYPE.CAR]: 'Car',
  [REF_ASSET_TYPE.MOTORBIKE]: 'Motorbike',
  [REF_ASSET_TYPE.CARAVAN]: 'Caravan',
  [REF_ASSET_TYPE.OTHER]: 'Other',
}
